// @ts-check

import DateTimeHelper from 'infrastructure/js/utils/dateTimeHelper';


const schedulerFormat = 'YYYY-MM-DD HH:mm:ss';


export default class GanttShiftsCoalescer {


  /**
   * @param {any[]} arr
   * 
   * @returns {Map<number, any[]>}
   */
  static #groupByResourceId = (arr) => {

    let map = new Map();

    for (let x of arr) {
      let key = x.resourceId;
      if (!map.has(key)) {
        map.set(key, []);
      }
      map.get(key).push(x);
    }

    return map;
  };



  /**
   * @param {any} x
   * 
   * @returns {any}
   */
  static #copyShiftObject = (x) => {
    let copy = {
      id: null,
      resourceId: x.resourceId,
      startDate: x.startDate,
      endDate: x.endDate,
      name: '',
      timeRangeColor: '',
      cls: 'pl-scheduler-shift',

      epochStartDate: x.epochStartDate,
      epochEndDate: x.epochEndDate,

    };
    return copy;
  };


  /**
   * @param {any[]} arr
   * @returns {any[]}
   */
  static #coalesceSingleResourceShifts = (arr) => {

    const ALLOWED_GAP_SEC = 0;
    // const MAX_JOINS = 20;


    arr.sort((a, b) => a.epochStartDate - b.epochStartDate);

    let outputArr = [];
    let accumulator = null;
    let joinCount = 0;

    let arrLen = arr.length;
    for (let i = 0; i < arrLen; i++) {

      let x = arr[i];

      // First ever.
      if (i === 0) {
        accumulator = GanttShiftsCoalescer.#copyShiftObject(x);
        outputArr.push(accumulator);
        continue;
      }


      // // Join limit reached.
      // if (joinCount >= MAX_JOINS) {
      //   // console.warn(`GanttShiftsCoalescer: MAX_JOINS (${MAX_JOINS}) reached for resourceId ${x.resourceId}. Starting new streak.`);
        
      //   // Start new streak.
      //   accumulator = GanttShiftsCoalescer.#copyShiftObject(x);
      //   outputArr.push(accumulator);
      //   joinCount = 0;
        
      //   continue;
      // }

      // Gap too large.
      let gapSec = x.epochStartDate - accumulator.epochEndDate;
      if (gapSec > ALLOWED_GAP_SEC) {

        // Start new streak.
        accumulator = GanttShiftsCoalescer.#copyShiftObject(x);
        outputArr.push(accumulator);
        joinCount = 0;
        
        continue;
      }

      // Merge into previous.
      accumulator.epochEndDate = x.epochEndDate;
      joinCount++;
      continue;

    }


    return outputArr;
  };


  /**
   * @param {any[]} arr
   * 
   * @returns {void}
   */
  static #prepareArrayForGantt = (arr) => {
    // console.log('prepareArrayForGantt ===> ', arr);

    for (let i = 0; i < arr.length; i++) {
      let x = arr[i];

      let dStart = DateTimeHelper.ConvertToDate({ epochDateTime: x.epochStartDate });
      let dEnd = DateTimeHelper.ConvertToDate({ epochDateTime: x.epochEndDate });
      if (!dStart) {
        console.error('dStart is null! ===> ', x);
        return;
      }
      if (!dEnd) {
        console.error('dEnd is null! ===> ', x);
        return;
      }

      x.startDate = dStart.format(schedulerFormat);
      x.endDate = dEnd.format(schedulerFormat);

      x.id = i + 1;

      // delete x.epochStartDate;
      // delete x.epochEndDate;

    }


  };


  /**
   * @param {any[]} arr
   * 
   * @returns {any[]}
   */
  static coalesceShifts = (arr) => {
    // console.log('arr ===> ', arr);

    // let t0 = performance.now();

    let map = GanttShiftsCoalescer.#groupByResourceId(arr);
    // console.log('map ===> ', map);
    let outputArr = [];
    for (let [key, value] of map) {
      let coalesced = GanttShiftsCoalescer.#coalesceSingleResourceShifts(value);
      outputArr.push(...coalesced);
    }

    // Convert dates, add ids, etc.
    GanttShiftsCoalescer.#prepareArrayForGantt(outputArr);

    // let t1 = performance.now();
    // console.log(`GanttShiftsCoalescer.coalesceShifts took ${t1 - t0} milliseconds.`);

    return outputArr;
  };



}







